/**
 * Formats the delivery method price to two decimal places.
 * @param number
 * @returns
 */
const formatDeliveryMethodPrice = (price: number) => Number(price / 100).toFixed(2);

export default formatDeliveryMethodPrice;
